// Resolve a local appointment time only in the explicitly chosen service zone.
// Ambiguous fall-back times return both candidates for an explicit user choice.
export function zonedCandidates(local, zone) {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(local || '') || !zone) return [];
  const [year, month, day, hour, minute] = local.match(/\d+/g).map(Number);
  const stamp = Date.UTC(year, month - 1, day, hour, minute);
  if (new Date(stamp).toISOString().slice(0, 16) !== local) return [];
  let format;
  try { format = new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); }
  catch { return []; }
  const matches = [];
  for (let offset = -14 * 60; offset <= 14 * 60; offset += 15) {
    const parts = Object.fromEntries(format.formatToParts(new Date(stamp - offset * 60000)).map(p => [p.type, p.value]));
    if (`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}` !== local) continue;
    const abs = Math.abs(offset);
    const suffix = `${offset >= 0 ? '+' : '-'}${String(Math.floor(abs / 60)).padStart(2, '0')}:${String(abs % 60).padStart(2, '0')}`;
    matches.push(`${local}:00${suffix}`);
  }
  return matches;
}
